export const pagesTestSetsEn = {
  detail: {
    basicInfo: {
      fields: {
        relatedRelease: 'Related Release',
        testLevel: 'Test Level',
        testPlan: 'Test Plan',
        testSetId: 'Test Design ID',
        testType: 'Test Type',
      },
      title: 'Basic Information',
    },
    breadcrumb: {
      home: 'Home',
      testSets: 'Test Sets',
    },
    conditions: {
      actions: 'Behaviors to Verify',
      constraints: 'Constraints & Dependency Rules',
      excludedSuffix: ' (Excluded)',
      factorLabel: 'Factor: {{name}}',
      factors: 'Factors & Levels',
      levelsLabel: 'Levels',
      noResults: 'No test conditions are registered.',
    },
    coverage: {
      placeholder: 'Coverage and technique matrices are coming soon.',
      sectionTitle: 'Test Coverage / Test Techniques',
    },
    designJudgement: {
      fields: {
        designMemo: 'Design Judgement Notes',
        regressionRequired: 'Regression Required',
        relatedTickets: 'Related Tickets',
        riskObservation: 'Risk Observations',
      },
      regressionRequiredOptions: {
        notRequired: 'Not Required',
        required: 'Required',
      },
      relatedTickets: {
        empty: 'No related tickets',
      },
      sectionTitle: 'Design Judgement & Traceability',
    },
    header: {
      fields: {
        automationRatio: 'Automation',
        itemCount: 'Items',
        ownerNotSet: 'Not set',
        product: 'Product',
        targetVersion: 'Target Version',
      },
    },
    options: {
      testSetLevel: {
        INTEGRATION: 'Integration',
        SYSTEM: 'System',
        UAT: 'UAT',
        UNIT: 'Unit',
      },
      testSetScope: {
        ABNORMAL: 'Abnormal',
        NORMAL: 'Normal',
        OTHER: 'Other',
        SEMI_NORMAL: 'Semi-Normal',
      },
      testSetStatus: {
        APPROVED: 'Approved',
        DESIGNING: 'Designing',
        EXECUTED: 'Executed',
        IMPLEMENTING: 'Implementing',
        NOT_EXECUTED: 'Not Executed',
        READY: 'Ready',
      },
      testSetType: {
        ACCESSIBILITY: 'Accessibility',
        COMPATIBILITY: 'Compatibility',
        FUNCTIONAL: 'Functional',
        INTEROPERABILITY: 'Interoperability',
        MAINTENANCE: 'Maintenance',
        NON_FUNCTIONAL: 'Non-Functional',
        OTHER: 'Other',
        PERFORMANCE: 'Performance',
        PORTABILITY: 'Portability',
        RELIABILITY: 'Reliability',
        SECURITY: 'Security',
        USABILITY: 'Usability',
      },
    },
    pageTitle: 'Test Set Detail',
    sidebar: {
      basicInfo: 'Basic Information',
      coverage: 'Test Coverage',
      dataRequirement: 'Data Requirements',
      designJudgement: 'Design Judgement',
      target: 'Test Target',
      technique: 'Test Technique',
    },
    tabs: {
      conditions: 'Test Conditions',
      items: 'Test Items',
      profile: 'Profile',
      results: 'Test Results',
      targetFunctions: 'Target Functions',
    },
    targetFunctions: {
      noResults: 'No target functions are scoped for this test set.',
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Status',
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SUB_MODULE: 'Sub Module',
        },
      },
    },
    testData: {
      fields: {
        requiredTestDataTypes: 'Required Test Data Types',
        testDataNotes: 'Test Data Notes',
        testDataPrecondition: 'Test Data Precondition',
      },
      sectionTitle: 'Test Data Requirements',
    },
    testTarget: {
      fields: {
        designDescription: 'Description',
        designScopes: 'Design Scopes',
      },
      sectionTitle: 'Test Target',
    },
  },
  list: {
    columns: {
      defectTicketCount: 'Defect Tickets',
      ngCount: 'NG',
      okCount: 'OK',
      owner: 'Owner',
      periodFrom: 'Start Date',
      periodTo: 'End Date',
      product: 'Product',
      skipCount: 'Skipped',
      status: 'Status',
      targetVersion: 'Target Version',
      testSetName: 'Test Set Name',
    },
    filterPlaceholder: 'Search by test set name',
    noResults: 'No test sets matched the current filter.',
    pageTitle: 'Test Sets',
    tabs: {
      all: 'All',
      approved: 'Approved',
      designing: 'Designing',
      executed: 'Executed',
      implementing: 'Implementing',
      notExecuted: 'Not Executed',
      ready: 'Ready',
    },
  },
};
